/* unplugin-vue-components disabled */import script from "./TagSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagSelector.vue?vue&type=script&setup=true&lang=ts"

import "./TagSelector.vue?vue&type=style&index=0&id=668c8942&lang=scss&scoped=true"
import "./TagSelector.vue?vue&type=style&index=1&id=668c8942&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-668c8942"]])

export default __exports__